import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class WorkStationsService {
  static async getAll({ page, search, idHeadquarter }) {
    const queryParams = {
      page,
      search,
      idHeadquarter,
    };
    const { data } = await DataService.get(API.workStations.root, queryParams);
    return {
      workStations: data.workStations,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getById(id) {
    const { data } = await DataService.get(`${API.workStations.root}/${id}`);
    return {
      workStation: data.workStation,
    };
  }

  static async create(workStationData) {
    const bodyParams = {
      name: workStationData.name,
      reference: workStationData.reference,
      idHeadquarter: workStationData.idHeadquarter,
    };
    const { data } = await DataService.post(API.workStations.root, bodyParams);
    return {
      workStation: data.workStation,
    };
  }

  static async update(id, workStationData) {
    const updateData = {
      name: workStationData.name,
      reference: workStationData.reference,
    };
    const { data } = await DataService.patch(`${API.workStations.root}/${id}`, updateData);
    return {
      workStation: data.workStation,
    };
  }

  static async getCurrent() {
    const { data } = await DataService.get(API.workStations.current);
    return {
      workStation: data.workStation,
    };
  }

  static async remove(id) {
    const { data } = await DataService.delete(`${API.workStations.root}/${id}`);
    return data;
  }
}

export { WorkStationsService };
